/** Bootstrap cookie the server sets (delivery channel, not the boundary). */
export const CSRF_COOKIE_NAME = 'csrf_token';
/** Header every write request carries the token in. */
export const CSRF_HEADER_NAME = 'X-CSRF-Token';
export const CSRF_BOOTSTRAP_ENDPOINT = {
    method: 'GET',
    path: '/api/v1/auth/csrf',
};
//# sourceMappingURL=csrf.js.map